import React, { useState } from "react";
import { formatRelativeTime } from "../utils/dateUtils";
import { supabase } from "../supabaseClient";

export default function RecentCircuitBenchmarks({ jobs, setJobs }) {

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;


    const totalPages = Math.ceil(jobs.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentJobs = jobs.slice(startIndex, startIndex + itemsPerPage);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    // ---------------------------------------------
    // Cancel Job Handler
    // ---------------------------------------------
    const cancelJob = async (id) => {
        if(!window.confirm("Are you sure?")){
            return;
        }

        // Update UI instantly
        setJobs((prev) =>
            prev.map((job) =>
                job.id === id ? { ...job, status: "CANCELLING" } : job
            )
        );

        const {data, error} = await supabase.from('jobs').update({status: 'CANCELLED'}).eq('id', id).select();
        if (error) throw error;
        // Update UI instantly
        setJobs((prev) =>
            prev.map((job) =>
                job.id === id ? { ...job, status: "CANCELLED" } : job
            )
        );

    };

    // ---------------------------------------------
    // Render Status Tags
    // ---------------------------------------------
    const renderStatus = (status) => {
        switch (status) {
            case "SUBMITTED":
                return <span className="tag is-warning">SUBMITTED</span>;
            case "QUEUED":
                return <span className="tag is-warning">Queued</span>;
            case "RUNNING":
                return (
                    <span className="tag is-info">
                        <span className="is-loading mr-2"></span>
                        Running
                    </span>
                );
            case "COMPLETED":
                return <span className="tag is-success">Completed</span>;
            case "CANCELLED":
                return <span className="tag is-light">CANCELLED</span>;
            default:
                return <span className="tag is-dark">{status}</span>;
        }
    };

    return (
        <>
            <table className="table is-fullwidth is-hoverable">
                <thead>
                    <tr>
                        <th>Status</th>
                        {/* <th>Snapshot</th> */}
                        <th>Submitted At</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>
                    {currentJobs.map((job) => (
                        <tr key={job.id}>
                            <td>{renderStatus(job.status)}</td>
                            {/* <td>#{job?.snapshot?.hash?.slice(0,6)}</td> */}
                            <td>{formatRelativeTime(job.created_at)}</td>

                            <td>
                                {job.status === "SUBMITTED" && (
                                    <button
                                        className="button is-small is-danger is-light"
                                        onClick={() => cancelJob(job.id)}
                                    >
                                        Cancel
                                    </button>
                                )}

                                {job.status === "RUNNING" && (
                                    <button className="button is-loading is-small is-static">
                                        Running
                                    </button>
                                )}

                                {job.status === "DONE" && (
                                    <a
                                        href={job.reportUrl}
                                        className="button is-small is-primary"
                                    >
                                        View Report
                                    </a>
                                )}

                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}
